import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { HelpService } from 'src/app/services/help.service';
import { InfoService } from '../../services/info.service';

@Component({
  selector: 'rqa-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, HttpClientModule, CardModule, TranslateModule]
})
export class HelpComponent implements OnInit {
  helpContent: string = '';
  version: string = '';
  private helpService = inject(HelpService);
  private infoService = inject(InfoService);

  ngOnInit(): void {
    this.helpService.getHelp().subscribe((help) => {
      this.helpContent = help.content;
    });
    this.infoService.getVersion().subscribe((response) => {
      this.version = response.value;
    });
  }
}
